<template>
  <div class="item" v-if="item.title">
    <v-sheet
      class="item-bg"
      :width="sm ? '100%' : '60%'"
      :style="`background-image: url(${files + item.bg});`"
      v-if="item.bg"
    ></v-sheet>

    <v-container class="relative">
      <v-row justify="center" justify-md="start">
        <v-col
          cols="12"
          sm="8"
          md="7"
          lg="6"
          class="py-8 py-sm-10 py-md-12 py-lg-16 item-caption"
        >
          <v-col cols="12" md="7" lg="6" class="pa-0">
            <Title :center="sm" v-if="item.title">
              {{ item.title }}
            </Title>
          </v-col>

          <div
            class="
              grey--text
              text--lighten-1 text-body-2 text-center text-md-left
              mt-6 mt-lg-8
              item-text
            "
            v-if="item.intro"
            v-html="item.intro"
          ></div>

          <div class="text-center text-md-left">
            <v-btn
              color="primary"
              :to="path"
              height="auto"
              class="
                text-body-1
                font-weight-bold
                text-none
                mt-7
                py-3
                px-7 px-md-10
              "
              depressed
              tile
            >
              Saiba mais
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "about",
  path: "/quem-somos",
};

export default {
  data: () => ({
    path: _config.path,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;
  position: relative;
  z-index: 10;
  &:after {
    background: rgb(255, 255, 255);
    background: -moz-linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 30%,
      rgba(255, 255, 255, 0) 100%
    );
    background: -webkit-linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 30%,
      rgba(255, 255, 255, 0) 100%
    );
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 30%,
      rgba(255, 255, 255, 0) 100%
    );
    content: "";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#ffffff",GradientType=1);
    height: 100%;
    left: 35%;
    position: absolute;
    right: 35%;
    top: 0;
    z-index: -1;
    @media screen and (min-width: 960.001px) and (max-width: 1264px) {
      background: -moz-linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 0) 100%
      );
      background: -webkit-linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 0) 100%
      );
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 0) 100%
      );
      left: 40%;
      right: 20%;
    }
    @media screen and (max-width: 959px) {
      background: -moz-linear-gradient(
        0,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 0) 100%
      );
      background: -webkit-linear-gradient(
        0,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 0) 100%
      );
      background: linear-gradient(
        0,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 0) 100%
      );
      left: 0;
      right: 0;
    }
  }
  .item-bg {
    background-position: top right;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    width: 60%;
    z-index: -1;
  }
}
</style>
